export default {"src":"/_next/static/media/ErrorIcon.842169b5.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};